import { AxiosProgressEvent } from 'axios';

export const getLoadedPercentage = (
  file: File,
  progressEvent: AxiosProgressEvent
): number => {
  let totalBytes: number;

  if (progressEvent.total != null && progressEvent.total > 0) {
    totalBytes = progressEvent.total;
  } else if (file.size > 0) {
    totalBytes = file.size;
  } else {
    totalBytes = 0;
  }
  const rawPercent = (progressEvent.loaded / totalBytes) * 100;
  return Math.min(100, Math.round(rawPercent));
};
